import React, { useEffect, useState } from 'react';
import { TooltipPlacement } from 'antd/lib/tooltip';
import ProductMatchInfo from 'src/types/ProductMatcheInfo';
import { useMatchRemovingState } from './hooks';
import SubmittedRequestPopover from '../SubmittedRequestPopover';
import PopConfirm from 'src/components/common/PopConfirm';

export type RemoveMatchButtonProps = {
  matchItems?: ProductMatchInfo[];
  className?: string;
  tooltipPlacement?: TooltipPlacement;
  onSelectedRow?: () => void;
};

const RemoveMatchButton: React.FC<RemoveMatchButtonProps> = ({
  matchItems,
  className,
  tooltipPlacement,
  onSelectedRow,
}) => {
  const [{ loading, data, error }, { removeMatch }] = useMatchRemovingState();
  const [showSubmittedPopover, setShowSubmittedPopover] = useState(false);
  const isResponseSuccessful = data && data.statusCode === '200';

  const handleDeleteConfirm = () => {
    if (removeMatch && matchItems) {
      removeMatch(matchItems);
    }
  };

  useEffect(() => {
    if (isResponseSuccessful) {
      onSelectedRow && onSelectedRow();
      setShowSubmittedPopover(true);
      setTimeout(() => {
        setShowSubmittedPopover(false);
      }, 5000)
    }
  }, [isResponseSuccessful]);

  return (
    <SubmittedRequestPopover visible={showSubmittedPopover} placement={tooltipPlacement || 'bottom'}>
      <PopConfirm
        title="Are you sure you want to remove these match(es)?"
        onConfirm={handleDeleteConfirm}
        icon={['fal', 'trash-alt']}
        className={className}
        tooltipPlacement={tooltipPlacement}
        isLoading={loading}
        errorMessage={error.message || error}
      />
    </SubmittedRequestPopover>
  );
};

export default RemoveMatchButton;
